import { Link } from 'react-router-dom';
import { juice } from '@/mocks/products';

const JuiceSection = () => {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden" style={{ fontFamily: "'Sora', sans-serif" }}>
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/8ef060a1bbd69b194763098d996297b6.jpg"
          alt="Uvas para suco integral"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-[#05344A]/90 via-[#05344A]/65 to-[#05344A]/25"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#05344A]/20 to-[#05344A]/45"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
          {/* Left - Painel: fundo cenário, garrafa ao centro, copo na frente */}
          <div className="relative rounded-2xl overflow-hidden" style={{ minHeight: 'clamp(520px, 90vw, 900px)' }}>
            {/* Fundo cenário uvas/mesa */}
            <img
              src="https://readdy.ai/api/search-image?query=dark-rustic-wooden-table-with-very-dark-almost-black-grape-clusters-scattered-around-vineyard-atmosphere-moody-warm-lighting-deep-purple-black-grapes-close-up-artisan-winery-scene-rich-dark-tones&width=800&height=900&seq=juice-panel-bg-v2&orientation=portrait"
              alt="Mesa rústica com uvas pretas"
              className="absolute inset-0 w-full h-full object-cover"
              style={{ objectPosition: 'center center' }}
            />
            <div className="absolute inset-0 bg-black/25"></div>

            {/* Garrafa — ocupa todo o painel, padding mínimo no mobile */}
            <img
              src={juice.image}
              alt="Garrafa Suco de Uva Integral Guarnieri"
              className="absolute inset-0 w-full h-full object-contain"
              style={{
                objectPosition: 'center bottom',
                filter: 'drop-shadow(0 40px 60px rgba(0,0,0,0.75))',
                zIndex: 10,
                padding: 'clamp(10px, 3vw, 20px) clamp(16px, 8vw, 60px) 0px clamp(16px, 8vw, 60px)',
              }}
            />

            {/* Copo na frente da garrafa — canto direito inferior */}
            <div
              className="absolute flex items-end"
              style={{ bottom: '0px', right: '16px', zIndex: 20 }}
            >
              <img
                src="https://public.readdy.ai/ai/img_res/88501933-7a4c-4c15-89f4-3c67a5ab0c3e.png"
                alt="Copo de suco de uva"
                className="block flex-shrink-0"
                style={{
                  height: 'clamp(160px, 28vw, 380px)',
                  width: 'auto',
                  objectFit: 'contain',
                  objectPosition: 'bottom',
                  filter: 'drop-shadow(0 16px 28px rgba(0,0,0,0.6))',
                  marginBottom: '-10px',
                }}
              />
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <div className="flex items-center gap-3 mb-5">
              <div className="w-8 h-px bg-[#6B9EBC]/60"></div>
              <span className="text-[#6B9EBC] text-xs font-semibold tracking-widest uppercase">100% Integral</span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-[#FCF1D7] mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Suco de Uva<br />
              <span className="text-[#6B9EBC] italic font-light">Integral</span>
            </h2>
            <p className="text-[#FCF1D7]/75 text-sm md:text-base leading-relaxed mb-8 max-w-md">
              100% uva bordô, sem adição de água ou açúcar. Puro, natural e cheio de vida. Rico em antioxidantes, polifenóis e vitaminas — tudo o que a natureza tem de melhor em cada gole.
            </p>

            {/* Benefits Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {juice.benefits.slice(0, 4).map((benefit) => (
                <div
                  key={benefit.title}
                  className="flex items-start gap-3 rounded-xl bg-[#FCF1D7]/10 backdrop-blur-sm border border-[#6B9EBC]/20 p-4 hover:border-[#6B9EBC]/40 transition-all"
                >
                  <div className="w-8 h-8 rounded-lg bg-[#05344A]/50 flex items-center justify-center flex-shrink-0">
                    <i className={`${benefit.icon} text-[#6B9EBC] text-base`}></i>
                  </div>
                  <div>
                    <p className="text-[#FCF1D7] font-semibold text-xs mb-0.5">{benefit.title}</p>
                    <p className="text-[#FCF1D7]/55 text-xs leading-relaxed line-clamp-2">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Badges */}
            <div className="flex flex-wrap gap-2 mb-8">
              {['Sem Açúcar', 'Sem Corantes', 'Sem Água Adicionada', '100% Integral'].map((badge) => (
                <span
                  key={badge}
                  className="bg-[#05344A]/50 border border-[#6B9EBC]/30 text-[#6B9EBC] text-xs px-3 py-1.5 rounded-full"
                >
                  {badge}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/suco"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-[#05344A] border border-[#6B9EBC]/40 text-[#FCF1D7] rounded-full text-sm font-semibold hover:bg-[#6B9EBC]/20 transition-all cursor-pointer whitespace-nowrap"
              >
                Conhecer os Benefícios <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://wa.me/5500000000000"
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-[#FCF1D7]/30 text-[#FCF1D7] rounded-full text-sm font-medium hover:bg-[#FCF1D7]/10 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Pedir Agora
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JuiceSection;
